import Home from '@/components/home.vue';
import IntendedUse from '@/components/intendedUse.vue';
import MenuPage from '@/components/menuPage.vue';
import Cancer from '@/components/cancer.vue';
import Dyslipidemia from '@/components/dyslipidemia.vue';
import Hypertension from '@/components/hypertension.vue';
import PCOS from '@/components/pcos.vue';
import Osteoarthritis from '@/components/osteoarthritis.vue';
import Type2Diabetes from '@/components/type2Diabetes.vue';
import LifeLost from '@/components/lifeLost.vue';
import Summary1 from '@/components/summary1.vue';
import Summary2 from '@/components/summary2.vue';
import MoreInfo from '@/components/moreInfo.vue';
import References from '@/components/references.vue';
import TermsConditions from '@/components/termsConditions.vue';
import Email from '@/components/email.vue';


export default [
  { path: '/', component: Home },
  { path: '/intendedUse', name: 'intendedUse', component: IntendedUse },
  { path: '/menu', name: 'menuPage', component: MenuPage },
  { path: '/cancer', name: 'cancer', component: Cancer },
  { path: '/dyslipidemia', name: 'dyslipidemia', component: Dyslipidemia },
  { path: '/hypertension', name: 'hypertension', component: Hypertension },
  { path: '/pcos', name: 'pcos', component: PCOS },
  { path: '/osteoarthritis', name: 'osteoarthritis', component: Osteoarthritis },
  { path: '/type2Diabetes', name: 'type2Diabetes', component: Type2Diabetes },
  { path: '/lifeLost', name: 'lifeLost', component: LifeLost },
  { path: '/summary1', name: 'summary1', component: Summary1 },
  { path: '/summary2', name: 'summary2', component: Summary2 },
  { path: '/moreInfo', name: 'moreInfo', component: MoreInfo },
  { path: '/references', name: 'references', component: References },
  { path: '/termsConditions', name: 'termsConditions', component: TermsConditions },
  { path: '/email', name: 'email', component: Email },
];
